import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import style from "./AllProjects.module.css";

import AdminNavBar from "../../NavBar/AdminNavBar";
import ProjectCard from "../../../../components/ProjectCard/ProjectCard";
import BreadCrumb from "../../../../components/BreadCrumb/BreadCrumb";
import ProjectCardLoader from "../../../../components/LoadingComponents/ProjectCardLoader/ProjectCardLoader";

export default function AllProjects() {

    const [projects, setProjects] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(true);
    const [filter, setFilter] = useState("your");
    const [error, setError] = useState("");
    const [message, setMessage] = useState("");

    const { employeeId } = useParams();
    const projectsPerPage = 6;

    const apiurl = process.env.REACT_APP_SERVER_URL;
    const token = localStorage.getItem("token");

    // Filter projects
    const filteredProjects =
        filter === "your"
            ? projects.filter((project) => project.createdBy === employeeId)
            : projects;

    // Pagination logic code
    const totalPages = Math.max(1, Math.ceil(filteredProjects.length / projectsPerPage));
    const indexOfLastProject = currentPage * projectsPerPage;
    const indexOfFirstProject = indexOfLastProject - projectsPerPage;
    const currentProjects = filteredProjects.slice(indexOfFirstProject, indexOfLastProject);

    const handleNext = () => currentPage < totalPages && setCurrentPage((p) => p + 1);
    const handlePrev = () => currentPage > 1 && setCurrentPage((p) => p - 1);

    // Fetch all projects once
    const fetchProjects = async () => {
        try {
            const res = await fetch(`${apiurl}/projects/all-projects`, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json",
                }
            });
            const data = await res.json();
            setProjects(data.projects || []);
        } catch (err) {
            setError(err.message || "Failed to load projects");
        } finally {
            setLoading(false);
        }
    };

    // Update message when filteredProjects changes
    const FilterProjects = () => {
        if (!loading && filteredProjects.length === 0) {
            setMessage(
                filter === "your"
                    ? "You have not created any projects yet."
                    : "No projects found."
            );
        } else {
            setMessage("");
        }
    }

    useEffect(() => {
        fetchProjects();
        FilterProjects();
    }, [apiurl, token, filteredProjects, filter, loading])

    return (
        <>
            <div className="container">
                <AdminNavBar />
                <div className={style.projectPage}>
                    <div className="row mt-lg-2 mb-0 ">

                        {/* BreadCrumb Linkss */}
                        <div className="col-8 col-lg-4 ">
                            <BreadCrumb
                                link={`/admin-dashboard/${employeeId}`}
                                name="Dashboard"
                                icon={true}
                            />
                            <BreadCrumb
                                link={`/admin-dashboard/${employeeId}/all-projects`}
                                name="All Projects"
                            />
                        </div>

                        {/* show the total Project for small Screen only */}
                        <div className="col-4 col-lg-0 pe-lg-5 pe-4 pt-1 d-lg-none">
                            <p className={style.breadcrumb}>
                                Projects: <b>{filteredProjects.length}</b>
                            </p>
                        </div>

                        {/* dummy component for ui purpose */}
                        <div className="col-lg-3"></div>

                        {/* select for filter the your and all projects list */}
                        <div className="col-4 col-lg-1 text-end ">
                            <select
                                className="form-select w-auto d-inline-block"
                                value={filter}
                                onChange={(e) => {
                                    setFilter(e.target.value);
                                    setCurrentPage(1);
                                }}
                            >
                                <option value="your">Your Projects</option>
                                <option value="all">All Projects</option>
                            </select>
                        </div>

                        {/* new project link button */}
                        <div className="col-7 col-lg-2 text-end me-1 text-lg-end mt-lg-1">
                            <Link
                                to={`/admin-dashboard/${employeeId}/create-project`}
                                style={{ textDecoration: "none" }}
                                className={`${style.newProject} ps-2 pe-2 bg-light rounded`}
                            >
                                New Project +
                            </Link>
                        </div>

                        {/* show the total Project for Large Screen only */}
                        <div className="d-none d-lg-block text-lg-end pt-2 col-lg-1   pe-5 pe-lg-0">
                            <p className={style.projectLength}>
                                Projects: <b>{filteredProjects.length}</b>
                            </p>
                        </div>
                    </div>

                    {/* message and Error Show components */}
                    <div className="row ">
                        {message && (
                            <p className="text-danger text-center" style={{ letterSpacing: "1px" }}>
                                {message}
                            </p>
                        )}
                        {error && <p className="text-danger text-center">{error}</p>}
                    </div>

                    {/* row Layout for show the loading and project data */}
                    <div className="row mb-4">

                        {/* loading Components */}
                        {loading ? (
                            Array.from({ length: 6 }).map((_, i) => (
                                <div className="col-12 col-md-6 col-lg-4 mb-lg-3" key={i}>
                                    <ProjectCardLoader />
                                </div>
                            ))
                        ) : (

                            // project card Component for fetch the project data
                            currentProjects.map((data) => (
                                <div className="col-12 col-md-6 col-lg-4 mb-lg-3" key={data._id}>
                                    <ProjectCard
                                        title={data.title}
                                        platform={data.platform}
                                        team={data.team}
                                        description={data.description}
                                        percentage={data.progress}
                                        link={`/admin-dashboard/${employeeId}/projects/${data._id}`}
                                    />
                                </div>
                            ))
                        )}
                    </div>
                </div>
            </div>

            {/* Bottom pagination  */}
            <div className="row mb-5">
                <div className="col-12 text-center">
                    <button
                        style={{ border: "none" }}
                        className="btn mx-2"
                        onClick={handlePrev}
                        disabled={currentPage === 1}
                    >
                        <b>{"<<"}</b>
                    </button>
                    <span className="mx-2">
                        Page {currentPage} of {totalPages}
                    </span>
                    <button
                        style={{ border: "none" }}
                        className="btn mx-2"
                        onClick={handleNext}
                        disabled={currentPage === totalPages}
                    >
                        <b>{">>"}</b>
                    </button>
                </div>
            </div>
        </>
    );
}
